import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-delete-modal',
  imports: [],
  templateUrl: './delete-modal.component.html',
  styleUrl: './delete-modal.component.scss'
})
export class DeleteModalComponent {
 @Input() details: any;
  @Input() id : any;



  @Output() confirmdeletion = new EventEmitter();
  
  @ViewChild('delete') public templateRef: TemplateRef<any>;
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered modal-md',
  };
  consumerModal = {
    userProfile: undefined,
  }
  constructor(private modalService: BsModalService) { }
  modalRefChild: BsModalRef;

  ngOnInit(): void {
  }

  idtodelete: any;
  openModal(id: any) {
    this.idtodelete=id
    this.modalRefChild = this.modalService.show(this.templateRef, this.config);
  }
  openModal2() {
    this.modalRefChild = this.modalService.show(this.templateRef, this.config);
  }
  closeModel() {
    this.modalRefChild.hide();
  }
  confirm(){
    this.confirmdeletion.emit(this.idtodelete);
    this.modalRefChild.hide();
  }

}
